module.exports = __webpack_public_path__ + "img/a-prod-fish-fisher-4320-wireless-position-monitor-x0899-1-.9f6b2dde.png";